// extracted by css-extract-rspack-plugin
export default {"content":"pW0Mi27___content","list":"TFv8Wfq___list"};